// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Toastr } from "@revvsales/components";

// Action Imports
import { docAfterAccepAndSignAction } from "../../../../actions/DocumentActions";

// Internal Imports
import SIGNATURE from "../../../../assets/Signature-icon.png";
import { GlobalUtils } from "../../../../utils";

// Declarations
const { readDataFromLocalStorage } = GlobalUtils;
// const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

class eSignApprovalBtn extends Component {
  state = {
    showBtnLoader: false,
  };

  _onAcceptAndEsignBtnClick = () => {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

    const { docID, docRecipientList } = this.props;
    // Find the sharing hash for e-sign
    const sharingHash = docRecipientList.find(
      item => item.user && item.user.id === CURRENT_USER.id,
    ).sharing_hash;

    this.setState({ showBtnLoader: true });
    this.props
      .docAfterAccepAndSignAction(docID, sharingHash)
      .then(res => {
        this.setState({ showBtnLoader: false });
        window.open(res.signingUrl, "_blank");
      })
      .catch(error => {
        console.error(
          `QuotationTopBarV3 => eSignApprovalBtn => _onAcceptAndEsignBtnClick => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
        this.setState({ showBtnLoader: false });
      });
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    // Check if current user is a recipient to do e-sign

    const DOC_RECIPIENT = this.props.docRecipientList.find(
      item => item.user && item.user.id === CURRENT_USER.id,
    );

    const SHOW_ESIGN_APPROVAL_BTN =
      DOC_RECIPIENT && DOC_RECIPIENT.recipient_type === "SIGNER";

    if (SHOW_ESIGN_APPROVAL_BTN) {
      return (
        <div className="esignapprovalbtn-outer-wrapper">
          <div className="esignapprovalbtn-wrapper">
            <div>
              <img
                src={SIGNATURE}
                alt="Revv"
                className="esignapprovalbtn-icon"
              />
            </div>
            <div className="esignapprovalbtn-txt">
              This document needs your eSignature. Please click
              <b> Proceed to eSign</b> to begin signing ceremony.
            </div>
            <Button
              className="esignapprovalbtn-btn"
              data-test="esignapprovalbtn-btn"
              isLoading={this.state.showBtnLoader}
              onClick={this._onAcceptAndEsignBtnClick}>
              Proceed to eSign
            </Button>
          </div>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = state => {
  const {
    document: { id: docID },
    docRecipientList = [],
  } = state.DocumentStore;
  return { docID, docRecipientList };
};

const mapDispatchToProps = {
  docAfterAccepAndSignAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(eSignApprovalBtn);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Buttons/eSignApprovalBtn/index.js